import { TemplateControl, TemplateBlock } from '../request-result-modal.types';

/**
 * Utility class for extracting polygon data from template controls
 */
export class PolygonExtractor {
  /**
   * Extract polygon data from all blocks and steps
   */
  static extractFromBlocks(blocks: TemplateBlock[]): string | undefined {
    for (const block of blocks) {
      if (block.controls) {
        for (const control of block.controls) {
          if (this.isPolygonControl(control)) {
            const polygon = this.getPolygonJsonFromControl(control);
            if (polygon) return polygon;
          }
        }
      }
      if (block.steps) {
        for (const step of block.steps) {
          for (const control of step.controls) {
            if (this.isPolygonControl(control)) {
              const polygon = this.getPolygonJsonFromControl(control);
              if (polygon) return polygon;
            }
          }
        }
      }
    }
    return undefined;
  }

  /**
   * Check if control is a polygon control
   */
  static isPolygonControl(control: TemplateControl): boolean {
    return control.name === 'polygon' && !!control.resultValues;
  }

  /**
   * Convert polygon control data to WKT format
   */
  static getPolygonJsonFromControl(control: TemplateControl): string | undefined {
    try {
      const resultValue = this.getResultValueAsString(control);
      if (!resultValue) return undefined;

      const trimmed = resultValue.trim();
      if (/^POLYGON\s*\(/i.test(trimmed)) {
        return trimmed;
      }

      const parsed = JSON.parse(resultValue);
      if (Array.isArray(parsed) && parsed.length > 0) {
        const realCoords = parsed.map(coord => [coord[1], coord[0]] as [number, number]);
        return `POLYGON ((${realCoords
          .map((coord: [number, number]) => `${coord[0].toFixed(6)} ${coord[1].toFixed(6)}`)
          .join(', ')}))`;
      }
    } catch (e) {
      console.error('Error parsing polygon data:', e);
    }
    return undefined;
  }

  private static getResultValueAsString(control: TemplateControl): string {
    if (typeof control.resultValues !== 'string') {
      return '';
    }
    const text = control.resultValues.trim();
    if (text === '' || text === '-' || text === '[]' || text === 'null') {
      return '';
    }
    return control.resultValues;
  }
}

